/**
 * Client for Google Analytics Universal.
 */
var GoogleAnalyticsUniversalClient = /** @class */ (function () {
    function GoogleAnalyticsUniversalClient(config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        /**
         * Send a event to Google Analytics Universal.
         * @var eventCategory The categorie of the event. It's equal to the trackingPrefix in our case.
         * @var eventAction The action of the event e.g. click/show/manualClose
         * @var eventLabel The label is a combination of the shortend widgettype and
         * @var nonInteraction Turn the non interaction on when the event should not influence the bounce rate.
         */
        this.event = function (eventCategory, eventAction, eventLabel, nonInteraction) {
            if (nonInteraction === void 0) { nonInteraction = false; }
            var trackersNames = _this.getGATrackerNames();
            for (var _i = 0, trackersNames_1 = trackersNames; _i < trackersNames_1.length; _i++) {
                var trackerName = trackersNames_1[_i];
                _this.ga(trackerName + ".send", {
                    eventAction: eventAction,
                    eventCategory: eventCategory,
                    eventLabel: eventLabel,
                    hitType: "event",
                    nonInteraction: nonInteraction,
                });
            }
        };
        /**
         * Set a config property
         * @var key The config key
         * @var value The config value
         */
        this.set = function (key, value) {
            var trackersNames = _this.getGATrackerNames();
            for (var _i = 0, trackersNames_2 = trackersNames; _i < trackersNames_2.length; _i++) {
                var trackerName = trackersNames_2[_i];
                _this.ga(trackerName + ".set", key, value);
            }
        };
        /**
         * getLinkerParam
         */
        this.getLinkerParam = function () {
            var _a, _b;
            return (_b = (_a = _this.ga.getAll()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.get("linkerParam");
        };
        var remoteContext = window;
        var clientName = remoteContext.GoogleAnalyticsObject;
        this.ga = remoteContext[clientName];
        this.trackerBlacklist = config.trackerBlacklist || [];
        this.gaTrackers = [];
    }
    /**
     * Collect the name of trackers
     * @returns string[] Tracker names
     */
    GoogleAnalyticsUniversalClient.prototype.resolveGATrackerNames = function () {
        var gaTrackers = [];
        var trackerList = this.ga.getAll();
        if (trackerList.length === 0) {
            gaTrackers.push("t0");
        }
        for (var _i = 0, trackerList_1 = trackerList; _i < trackerList_1.length; _i++) {
            var tracker = trackerList_1[_i];
            if (this.trackerBlacklist.indexOf(tracker.get("trackingId")) === -1) {
                gaTrackers.push(tracker.get("name"));
            }
        }
        return gaTrackers;
    };
    /**
     * Getter for the tracker names
     * @returns string[] Tracker names
     */
    GoogleAnalyticsUniversalClient.prototype.getGATrackerNames = function () {
        if (this.gaTrackers.length === 0) {
            this.gaTrackers = this.resolveGATrackerNames();
        }
        return this.gaTrackers;
    };
    return GoogleAnalyticsUniversalClient;
}());
export default GoogleAnalyticsUniversalClient;
//# sourceMappingURL=GoogleAnalyticsUniversalClient.js.map